export default "__VITE_ASSET__D$7b7Ll0__"